import { render, staticRenderFns } from "./ProductVerificationStep.vue?vue&type=template&id=2d91d6a1&scoped=true&"
import script from "./ProductVerificationStep.vue?vue&type=script&lang=js&"
export * from "./ProductVerificationStep.vue?vue&type=script&lang=js&"
import style0 from "./ProductVerificationStep.vue?vue&type=style&index=0&id=2d91d6a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91d6a1",
  null
  
)

export default component.exports